import {useQuery} from '@tanstack/react-query';
import {apiClient} from '@common/http/query-client';
import {BackendResponse} from '@common/http/backend-response/backend-response';

interface Subscription {
  id: number;
  package_id?: number;
  name?: string;
  start?: string;
  end?: string;
  storage?: string | number;
  amount?: string | number;
  status?: number; // 1 = active, 2 = expired
}

interface FetchMySubscriptionsResponse extends BackendResponse {
  data: Subscription[];
  totalGB: number;
}

export function useMySubscriptions() {
  return useQuery({
    queryKey: ['my-subscriptions'],
    queryFn: fetchMySubscriptions,
    select: response => ({
      subscriptions: response.data,
      totalGB: response.totalGB,
    }),
  });
}

async function fetchMySubscriptions(): Promise<FetchMySubscriptionsResponse> {
  // Generate a token first
  const tokenResponse = await apiClient.post('drive/generate-token', {
    endpoint_type: 'subscriptions',
  });

  const token = tokenResponse.data.token;

  // Call external API directly with fetch
  const response = await fetch('https://apcrosa.syscomlive.co.uk/api/v1/drive/subscriptions/get-my', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-API-Token': token,
    },
    body: JSON.stringify({
      use_for_drive: true,
    }),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const result = await response.json();

  // Transform the response to match expected format
  return {
    data: result.data || [],
    totalGB: result.totalGB || 0,
  };
}
